import { MarketingType } from '@amzn/fire-tv-campaign-automation-service';

const MARKETING_TYPE_DISPLAY_NAMES: Record<MarketingType, string> = {
  [MarketingType.PRODUCT_DISCOVERY_AND_PRODUCT_LISTING]: 'Product discovery or product listing',
  [MarketingType.EDUCATIONAL_INFORMATIONAL]: 'Educational/informational',
  [MarketingType.DEALS_OFFERS_AND_PROMOTIONS]: 'Deals, offer, and promotions',
  [MarketingType.EDITORIAL]: 'Editorial',
};

export function getMarketingTypeOptions() {
  return Object.entries(MARKETING_TYPE_DISPLAY_NAMES).map(([value, name]) => ({
    value,
    name,
  }));
}
